import {Line} from '../../../schemas';

export default (composite) => {
  return composite.lines
    .map(decodeLine)
    .map(fillRowsAndSeats);
};

const LINE_TYPES = {
  COMPOSITE_TYPE_NUMERIC: 1,       // n
  COMPOSITE_TYPE_ULTRA_GENERAL: 2  // u
};

// Parse and decode each individual composite block and returns a valid "line" object
const decodeLine = (composite) => {
  if (!composite || !composite.from) {
    return new Error('MNX Geometry parser - composite does not have the from property');
  }

  let line = new Line();

  // start by breaking down the component elements
  const cmpFrom = composite.from.split(',');
  const cmpMapTo = composite.map_to ? composite.map_to.split(',') : [0, 0];

  // set aside the section name
  line.section_name = cmpFrom[0];
  line.map_to_y = +cmpMapTo[0];
  line.map_to_x = +cmpMapTo[1];

  switch (composite.type) {
    case 'n':
      line.element_type = LINE_TYPES.COMPOSITE_TYPE_NUMERIC;
      line.start_row    = +cmpFrom[1];
      line.end_row      = +cmpFrom[2];
      line.start_seat   = +cmpFrom[3];
      line.end_seat     = +cmpFrom[4];
      line.row_step     = composite.row_step ? +composite.row_step : 1;
      line.seat_step    = composite.seat_step ? +composite.seat_step : 1;
      line.seat_inc     = composite.seat_inc ? +composite.seat_inc : 0;
      line.row_inc      = composite.row_inc ? +composite.row_inc : 0;
      line.seat_selection_reverse = composite.seat_selection_reverse ? +composite.seat_selection_reverse : 0;
      break;
    case 'u':
      line.element_type = LINE_TYPES.COMPOSITE_TYPE_ULTRA_GENERAL;
      line.rows = cmpFrom[1].split(';');
      line.seats = cmpFrom[2].split(';');
      break;
    default:
      throw new Error('MNX Geometry parser - Wrong composite type');
  }

  return line;
};

// From each decoded line this function will fill in the rows and seats arrays
// skip seats that are not present in the availability data
const fillRowsAndSeats = (line) => {

  // TODO, improve this! THIS WHOLE FUNC
  switch (line.element_type) {
    case LINE_TYPES.COMPOSITE_TYPE_NUMERIC:

      if (isNaN(line.start_row) || isNaN(line.end_row)) {
        console.warn('MNX Geometry parser - unable to parse a line in composites array', line);
        return line;
      }
      // loop over rows and seats (incrementing or decrementing depending on row/seat step)
      for (let row = line.start_row; row !== line.end_row + line.row_step; row += line.row_step) {
        line.rows.push(row);
        for (let seat = line.start_seat; seat !== line.end_seat + line.seat_step; seat += line.seat_step) {
          line.seats.push(seat);
        }
      }

      return line;
    default:
      return line;
  }
};



// WEBPACK FOOTER //
// ./frontend/react/sim/parser-mnx-geometry/src/decoders/composite_decoder.js